import { render, staticRenderFns } from "./VerCorreos.vue?vue&type=template&id=43941dd6"
import script from "./VerCorreos.vue?vue&type=script&lang=js"
export * from "./VerCorreos.vue?vue&type=script&lang=js"
import style0 from "./VerCorreos.vue?vue&type=style&index=0&id=43941dd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports